let businessContextEpoch = 0

export function captureBusinessContextEpoch() {
  return businessContextEpoch
}

export function isBusinessContextEpochCurrent(epoch: number) {
  return businessContextEpoch === epoch
}

export function createBusinessContextRuntimeGuard(options: {
  getToken: () => string | undefined
  getScopeId: () => string
  isAdditionalCurrent?: () => boolean
}) {
  const epoch = captureBusinessContextEpoch()
  const token = options.getToken() ?? ""
  const scopeId = options.getScopeId()
  return {
    epoch,
    token,
    scopeId,
    isCurrent: () =>
      isBusinessContextEpochCurrent(epoch)
      && (options.getToken() ?? "") === token
      && options.getScopeId() === scopeId
      && (options.isAdditionalCurrent?.() ?? true),
  }
}

/**
 * Invalidates active and queued context work without coupling request, router
 * and store modules to the transaction manager.
 */
export function invalidateBusinessContextEpoch() {
  businessContextEpoch += 1
}

export function resetBusinessContextEpochForTest() {
  businessContextEpoch += 1
}
